// extracted by mini-css-extract-plugin
export default {"TwoDimsFeature":"wr_a bie_b bie_we"};